var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckInboxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#check-inbox-icon_svg__clip0_7259_75593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.594 35.645a2.682 2.682 0 01-2.475 2.383l-.32.022c-.787.053-1.4.707-1.4 1.497v2.985c0 1.004-1.149 1.573-1.947.965-1.458-1.11-3.396-2.761-4.586-4.473a1.497 1.497 0 00-1.24-.64c-3.663.02-7.326-.099-10.989-.356a2.677 2.677 0 01-2.475-2.377 68.117 68.117 0 010-14.866 2.677 2.677 0 012.474-2.377 146.034 146.034 0 0120.482 0 2.678 2.678 0 012.475 2.377 68.09 68.09 0 010 14.86z",
    fill: "#2F54EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.391 21.5a2.578 2.578 0 002.38 2.292l.307.02c.757.052 1.346.681 1.346 1.44v2.87c0 .966 1.105 1.514 1.873.929 1.401-1.067 3.266-2.655 4.41-4.302a1.44 1.44 0 011.193-.614c3.522.018 7.043-.096 10.566-.343a2.575 2.575 0 002.38-2.286c.521-4.764.521-9.53 0-14.295a2.574 2.574 0 00-2.38-2.285 140.404 140.404 0 00-19.694 0 2.575 2.575 0 00-2.38 2.285 65.485 65.485 0 000 14.29z",
    fill: "#ADC6FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "check-inbox-icon_svg__clip0_7259_75593"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(4 4)",
    d: "M0 0h40v40H0z"
  })))));
}

export default __webpack_public_path__ + "./fonts/check-inbox-icon.fdf2b70b5e903efc003ccba617f2a2f3.svg";
export { SvgCheckInboxIcon as ReactComponent };